import { useRecoilCallback } from 'recoil';
import {
  hasUnsavedChangesState,
  hasUnsavedPortfolioChangesInAllocator,
  baselineAnalysisView,
  currentAnalysisView,
  openAllocatorSubject,
  allocatorAnalysisSubject,
  originalAnalysisSubjectQuery,
  useSendSignal,
} from 'venn-state';

export const useProxyChangeHandler = () => {
  const refreshStudioView = useSendSignal({ type: 'WorkspaceConfigurationUpdate' });

  const syncAfterProxyChange = useRecoilCallback(
    ({ snapshot, set }) =>
      async (updateBaseline: boolean) => {
        if (updateBaseline) {
          const currentView = await snapshot.getPromise(currentAnalysisView);
          set(baselineAnalysisView, currentView);
        }

        const openSubject = await snapshot.getPromise(openAllocatorSubject);
        if (openSubject) {
          const refreshedOriginal = await snapshot.getPromise(originalAnalysisSubjectQuery(openSubject));
          if (refreshedOriginal) {
            set(allocatorAnalysisSubject(openSubject), refreshedOriginal);
          }
        }
      },
    [],
  );

  const handleProxyChange = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const hadUnsavedChanges = await snapshot.getPromise(hasUnsavedChangesState);
        const hadUnsavedAllocatorChanges = await snapshot.getPromise(hasUnsavedPortfolioChangesInAllocator);

        refreshStudioView();

        if (!hadUnsavedAllocatorChanges) {
          setTimeout(() => syncAfterProxyChange(!hadUnsavedChanges), 100);
        }
      },
    [refreshStudioView, syncAfterProxyChange],
  );

  return handleProxyChange;
};
